'use strict';

require('./page-root.scss');

var React = require('react');

var PageRoot = React.createClass({
    render: function() {
        return (
            <div className="page-root">
                {this.props.children}
            </div>
        );
    }
});

module.exports = PageRoot;



// WEBPACK FOOTER //
// ./src/client/components/page-root/page-root.jsx